import React from 'react'
import { Button } from '@chakra-ui/react'

export const ConfirmButton = ({ onClick, isDisabled, isLoading }) => (
  <Button
    w="100%"
    h="40px"
    bg="primary.main"
    color="white"
    fontSize="sm"
    fontWeight="600"
    onClick={onClick}
    disabled={isDisabled}
    loading={isLoading}
    _hover={{ opacity: 0.8 }}
  >
    確認画面へ
  </Button>
)
